const ID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

/**
 * The page as Google Analytics is told it: the path with record ids replaced, never the tab's title, which carries
 * patient and user names. Pages of the same kind then also count together (every patient's chart as one page).
 * @param {string} pathname
 */
export const analyticsPage = pathname => pathname.replace(ID, ':id')

/** Google Analytics fields that stand in for the tab's title and address on everything it sends from now on */
export const analyticsPageFields = pathname => {
  const page = analyticsPage(pathname)
  return { page_title: page, page_location: `${window.location.origin}${page}` }
}
